import React from 'react'
import algoliasearch from 'algoliasearch/lite'
import { InstantSearch, SearchBox, Hits } from 'react-instantsearch-dom'
import { connectStateResults } from 'react-instantsearch/connectors'

import { MobileHit } from '../index'

import { StyledHits } from './Search.styled.js'
import styles from './MobileSearch.module.sass'

const searchClient = algoliasearch(
  'UYRMCLQMSH',
  '675318f0d9a30afa422bcbaf5da3b059'
)

const Results = connectStateResults(
  ({ searchState, searchResults, children }) =>
    searchResults && searchResults.nbHits > 40 ? null : searchResults &&
      searchResults.nbHits !== 0 ? (
      children
    ) : (
      <div className="ais-Hits">
        <p className={styles.added}>
          No results have been found for {searchState.query}.
        </p>
      </div>
    )
)

const MobileSearch = () => {
  return (
    <div className={styles.mobileSearch}>
      <InstantSearch searchClient={searchClient} indexName="ECOM">
        <SearchBox />
        <Results>
          <StyledHits>
            <Hits hitComponent={MobileHit} />
          </StyledHits>
        </Results>
      </InstantSearch>
    </div>
  )
}
export default MobileSearch
